import React from 'react';
import { ProjectsList } from '../components/ProjectsList/ProjectsList';

export const ProjectsPage: React.FC = () => {
    return <ProjectsList />;
};